import { Link as GatsbyLink, GatsbyLinkProps, graphql, useStaticQuery } from 'gatsby';
import React, { useEffect, useMemo, useState } from 'react';

import { GatsbyImageWithFallback } from '../../../lib/gatsby/components/imageWithFallback';
// import styled from '@emotion/styled';
import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import Close from '@mui/icons-material/Close';
import HomeOutlined from '@mui/icons-material/HomeOutlined';
import Menu from '@mui/icons-material/Menu';



import {
  AppBar, Box,
  Button,
  Container, Divider,
  IconButton,
  Popover,
  Stack, SxProps, Theme, Toolbar,
  useTheme
} from '@mui/material';
import {StrapiContentStatus} from "../../../lib/mui/shared/utils";
import {LinkList} from "../../../lib/mui/components/linkList";
import {LinkGroupProps} from "../../../lib/mui/components/linkGroup";

const requiredPublishType: StrapiContentStatus = process.env.GATSBY_STRAPI_CONTENT_STATUS
// const desktopNavBarBottomBorderWidth = '7px'
// const desktopNavBarBottomBorderColor = "#F5F5F5"

export const mobileLinkStyle = (muiTheme: Theme) => ({
  display: "block",
  color: "#1A1A1A",
  zIndex: 1,
  fontSize: muiTheme.typography.h3.fontSize,
  paddingTop: muiTheme.spacing(1),
  paddingBottom: muiTheme.spacing(1),
  paddingLeft: muiTheme.spacing(4),
  paddingRight: muiTheme.spacing(4),
  marginBottom: muiTheme.spacing(1),
})

export const mobileAppFloatingMenuStyle = (muiTheme: Theme) => ({
  color: "white",
  zIndex: 999,
  // fontSize: muiTheme.typography.h3.fontSize,
  fontWeight: 'bold',
  top: 0,
  right: 0,
  left: 0,
  bottom: 0,
  pt: 12,
  pl: 1,
  pr: 1,
  position: "absolute",
  background: muiTheme.palette.primary.main,
})

const desktopNavItemBorderStyles = (theme: Theme) => ({
  borderStyle: 'solid',
  // borderColor: color,
  borderWidth: '0',
  // borderBottomWidth: desktopNavBarBottomBorderWidth,
})
const navLinkActiveStyles = (theme: Theme) => ({
  color: theme.palette.primary.main,
  ...desktopNavItemBorderStyles(theme)
})

const navLinkStyles = (theme: Theme): SxProps => ({
  color: 'inherit',
  fontWeight: 'normal',
  fontSize: '1rem',
  height: '48px',
  textDecoration: 'none',
  ...desktopNavItemBorderStyles(theme)
})

export const desktopAppBarStyle = (theme: Theme) => ({
  background: '#F3F3F3',
  color: theme.palette.text.primary,
  // pt: 2,
  display: {
    xs: "none",
    sm: "none",
    md: "inherit",
    lg: "inherit",
    xl: "inherit",
  },
  // height: '48px',
  boxShadow: 'none',
  // boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.30), 0px 2px 6px 2px rgba(0, 0, 0, 0.15)',
  ...desktopNavItemBorderStyles(theme)
  // width: "100%",
  // top: 0,
  // left: 0,
  // right: 0,
})

export const desktopTopAppBarStyle = (theme: Theme) => ({
  background: theme.palette.secondary.dark,
  color: theme.palette.secondary.contrastText,
  pt: theme.spacing(0.5),
  pb: theme.spacing(0.5),
  pr: theme.spacing(0),
  display: {
    xs: "none",
    sm: "none",
    md: "inherit",
    lg: "inherit",
    xl: "inherit",
  },
  // width: "100%",
  // top: 0,
  // left: 0,
  // right: 0,
})

export const desktopMiddleAppBarStyle = (theme: Theme): SxProps => ({
  // background: theme.palette.brandGreen.main,
  // background: hasHero ? 'none' : 'linear-gradient(180deg, rgba(106, 189, 69, 0.3) 0%, rgba(0, 78, 23, 0.8) 100%)',
  background: 'linear-gradient(180deg, rgba(106, 189, 69, 0.3) 0%, rgba(0, 78, 23, 0.8) 100%)',
  color: theme.palette.brandGreen.contrastText,
  pt: theme.spacing(2),
  pb: theme.spacing(2),
  position: 'absolute',
  zIndex: 999,
  top: 0,
  left: 0,
  right: 0,
  display: {
    xs: "none",
    sm: "none",
    md: "inherit",
    lg: "inherit",
    xl: "inherit",
  },
  // width: "100%",
  // top: 0,
  // left: 0,
  // right: 0,
})

export const mobileAppBarStyle = (theme): SxProps => ({
  // background: "transparent",
  // pt: 1,
  // pr: 1,
  // pl: 0,
  background: theme.palette.brandGreen.main,
  color: 'white',
  display: {
    xs: "inherit",
    sm: "inherit",
    md: "none",
    lg: "none",
    xl: "none",
  },
  // borderBottom: '4px solid #5F2116'
  // width: "100%",
  // top: 0,
  // left: 0,
  // right: 0,
})

export const baseLogoHeight = 48
export const baseLogoWidth = 230

export default function Header() {
  const headerDataQuery: Queries.HeaderComponentQuery = useStaticQuery(graphql`
    query HeaderComponent {
      strapiWebsiteInfo {
        companyName: CompanyName
      }
      strapiHeader {
        logo: Logo {          
          name
          url
          localFile {
            childImageSharp {
              gatsbyImageData(placeholder: NONE, height: 80, quality: 100)
            }
          }
        }
        actionLinks: ActionLinks {
          label: Label
          url: URL
          hidden: Hidden
          buttonType: Type
          buttonColor: Color
          icon: Icon
        }
        links: Links {
          url: URL
          label: Label
          hidden: Hidden
          # links: Links {
          #   label: Label
          #   url: URL
          #   hidden: Hidden
          # }
        }
      }
    }
  `)

  // const NotPrintable = useMemo(() => styled('div')(notPrintable), []);

  const headerProps = useMemo(() => {
    return { ...headerDataQuery }
  }, [])

  return (
    // <NotPrintable>
    // <MuiThemeProvider theme={appTheme}>
    <>
      <MobileHeader {...headerProps} />

      <DesktopHeader {...headerProps} /></>
    // </MuiThemeProvider>
    // </NotPrintable>
  )
}
type HeaderComponentProps = Queries.HeaderComponentQuery

// const TopAppBar = ({ sx, theme }: { sx: SxProps, theme: Theme }) => {
//   return <AppBar position="static" elevation={0} sx={{
//     ...sx, background: theme.palette.secondary.main,
//     color: theme.palette.secondary.contrastText,
//     borderBottom: '0',
//     py: 0.5,
//   }}>
//     <Container>
//       <Stack direction='row' justifyContent='center' alignItems='center' sx={{ width: '100%' }}>
//         <Typography variant="body2" sx={{ textAlign: { xs: 'center', sm: 'center', md: 'inherit' } }}>Warning</Typography>
//         {/* <Stack direction={'row'} gap={1}>
//               <Phone htmlColor={theme.palette.secondary.light} />
//               <Link forceLink variant='text' label={"Contact information"} relativeLinkComponent={GatsbyLink} url="/contact" />
//             </Stack> */}
//       </Stack>
//     </Container>
//   </AppBar>
// }

const DesktopHeader = ({ strapiHeader, strapiWebsiteInfo }: HeaderComponentProps) => {
  const theme = useTheme();
  const appBarStyle = desktopAppBarStyle(theme)
  const middleBarStyle = desktopMiddleAppBarStyle(theme)
  const navLinkActiveStyle = navLinkActiveStyles(theme)
  const logo = strapiHeader?.logo;
  const navLinkStyle = navLinkStyles(theme)

  // const navLinkSxActive = useMemo(() => ({ color: '#022A50' }), []);

  const iconMapping = useMemo(() => {
    return { 'Home': <HomeOutlined sx={{ fontWeight: 'normal', color: '#729E4F' }} /> }
  }, [])

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'top-menu' : undefined;

  return (
    <>
      {/* <TopAppBar sx={appBarStyle} theme={theme} /> */}
      <AppBar position="static" elevation={0} sx={{ ...middleBarStyle }}>
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <Stack
              sx={{ width: "100%" }}
              direction={"row"}
              justifyContent="space-between"
              alignItems="center"
            >
              <Stack
                direction={"row"}
                divider={<Divider orientation="vertical" sx={{ borderColor: theme.palette.secondary.dark, borderWidth: 1.2, mt: 4, mb: 4 }} flexItem />}
                justifyContent="flex-start"
                gap={6}
                alignItems="center"
              >
                <GatsbyLink to="/">
                  <Box sx={{ display: "none" }}>Home</Box>
                  {logo && <Box pt={1} pb={1}><GatsbyImageWithFallback url={logo.url} image={logo.localFile?.childImageSharp?.gatsbyImageData} alt={logo.name} /></Box>}
                </GatsbyLink>
              </Stack>

              <Box component="nav" aria-label="Main navigation">
                <Stack
                  direction={"row"}
                  justifyContent="space-evenly"
                  alignItems="center"
                  gap={4}
                  sx={{ color: 'white' }}
                >
                  {strapiHeader?.links && (
                    <Box>
                      <Button aria-describedby={id} endIcon={<ArrowDropDown />} variant="text" sx={{ color: 'white', textDecoration: 'none!important' }} onClick={handleClick}>
                        Menu
                      </Button>
                      <Popover
                        id={id}
                        open={open}
                        anchorEl={anchorEl}
                        disablePortal
                        onClose={handleClose}
                        slotProps={{
                          paper: {
                            sx: {
                              background: 'transparent',
                              // boxShadow: "none",
                              backgroundColor: 'rgba(255, 255, 255, 0.9)',
                              borderRadius: '20px',
                              // px: 2,
                              // py: 2,
                              // boxShadow: "none",
                            }
                          }
                        }}
                        anchorOrigin={{
                          vertical: 'bottom',
                          horizontal: 'left',
                        }}
                      >
                        <Stack
                          direction={"column"}
                          justifyContent="space-evenly"
                          alignItems="center"
                          sx={{ color: 'black' }}
                        >

                          <LinkList
                            LinkGroupHeaderLabelToIconMapping={iconMapping}
                            links={strapiHeader?.links as LinkGroupProps[]}
                            requiredPublishType={requiredPublishType}
                            LinkGroupItemsStackProps={{ gap: 0.5, sx: { width: '100%', textAlign: 'left' } }}
                            LinkGroupHeaderLinkProps={{ sx: { ...navLinkStyle, width: '100%', textAlign: 'left', px: 3, py: 2 } }}
                            LinkGroupHeaderTypographyProps={{ sx: navLinkStyle }}
                            withDropdown
                            StackProps={{ direction: "column", gap: 0, sx: { width: '100%', textAlign: 'left' } }}
                            // StackProps={{ direction: "row", gap: { md: 1, lg: 2 } }}
                            relativeLinkComponent={GatsbyLink}
                            onClick={() => setAnchorEl(null)}
                            LinkProps={{ activeStyle: navLinkActiveStyle, style: { textDecoration: 'none!important', color: 'black', width: '100%', textAlign: 'left' } } as GatsbyLinkProps<any> as any}
                          />
                        </Stack>
                      </Popover>
                    </Box>

                  )}
                  {strapiHeader?.actionLinks && (
                    <LinkList
                      // LinkGroupHeaderLabelToIconMapping={iconMapping}
                      links={strapiHeader?.actionLinks as LinkGroupProps[]}
                      // forceButton
                      LinkProps={{ underline: 'none', sx: { textDecoration: 'none!important' } }}
                      requiredPublishType={requiredPublishType}
                      // LinkGroupItemsStackProps={{ gap: 1 }}
                      // LinkGroupItemsTypographyProps={{ sx: { fontSize: '1rem!important', color: theme.palette.text.primary, pl: 0.5 } }}
                      // LinkGroupHeaderLinkProps={{ sx: { ...navLinkStyle } }}
                      // LinkGroupHeaderTypographyProps={{ sx: navLinkStyle }}
                      StackProps={{ direction: "row", gap: 4 }}
                      // StackProps={{ direction: "row", gap: { md: 1, lg: 2 } }}
                      relativeLinkComponent={GatsbyLink}
                    />)}
                </Stack>
              </Box>

            </Stack>
          </Toolbar>
        </Container>
      </AppBar>
    </>

  )
}

const MobileHeader = ({ strapiHeader }: HeaderComponentProps) => {
  const theme = useTheme()

  const appBarStyle = mobileAppBarStyle(theme)

  const openMenuStyle = mobileAppFloatingMenuStyle(theme)
  // const mobileLinkStyling = mobileLinkStyle(theme)
  const [isOpen, setOpen] = useState(false)
  const logo = strapiHeader?.logo;

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden"
      document.documentElement.style.overflow = "hidden"
    } else {
      document.body.style.overflow = ""
      document.documentElement.style.overflow = ""
    }
  }, [isOpen])

    const allLinks = useMemo(() => (strapiHeader?.actionLinks || []).concat(strapiHeader?.links as any || []) ?? [], [])

  const mobileCtas = useMemo(() => {
    const l = strapiHeader?.actionLinks || []
    if(l.length === 0) return []

    const cta = l.at(-1);
    if(!cta) return []

    return [
      {
        ...cta,
        icon: null,
        label: (cta.label || '').split(' ')[0]
      }
    ]
  }, [])

  return (
    <>
      {/* {!isOpen && <TopAppBar sx={appBarStyle} theme={theme} />} */}
      <AppBar position="static" elevation={0} sx={appBarStyle}>
        <Toolbar disableGutters sx={{ zIndex: 9999 }}>
          <Container sx={{ width: "100%" }}>
            <Stack
              sx={{ width: "100%", py: 1.5 }}
              spacing={6}
              direction={"row"}
              justifyContent="space-between"
              alignItems="center"
            >
              <GatsbyLink onClick={() => setOpen(false)} to="/">
                <Box sx={{ display: "none" }}>Home</Box>
                {logo && <GatsbyImageWithFallback style={{ width: '100%' }} url={logo.url} image={logo.localFile?.childImageSharp?.gatsbyImageData} alt={logo.name} />}
              </GatsbyLink>

              {/* <Box sx={{ width: '85px', height: '31px', visibility: isOpen ? 'hidden' : undefined }}><Button href="https:/google.com.au" size="small" sx={{ m: 0, py: '4px', width: '100%', whiteSpace: 'nowrap' }} color={"primary"} variant="contained">Quick exit</Button></Box> */}
              <Stack direction="row" alignItems="center" spacing={1}>
                {mobileCtas && (
                    <Box sx={{ visibility: isOpen ? 'hidden' : undefined }}>
                      <LinkList
                          links={mobileCtas as LinkGroupProps[]}
                          ButtonProps={{size: 'small'}}
                          LinkProps={{ underline: 'none', sx: { textDecoration: 'none!important' } }}
                          requiredPublishType={requiredPublishType}
                          StackProps={{ direction: "row", gap: 4 }}
                          relativeLinkComponent={GatsbyLink}
                      />
                    </Box>)}
                <IconButton
                  aria-label={isOpen ? "Close main menu" : "Open main menu"}
                  aria-expanded={isOpen}
                  sx={{ m: 0 }}
                  size='large'
                  onClick={() => setOpen(!isOpen)}
                >
                  {isOpen
                    ? <Close sx={{ color: "white" }} />
                    : <Menu sx={{ color: "white" }} />
                  }
                </IconButton>
              </Stack>
            </Stack>
          </Container>
        </Toolbar>
        {/* <Box sx={{ backgroundColor: '#f3f3f3', width: '100%' }}>
          <Container>
            {!isOpen && (
              <Stack
                direction="row"
                alignItems="center"
                width={"100%"}
                justifyContent={"flex-end"}
              >
                <Box>
                  <Button
                    title="Toggle menu"
                    sx={{ color: "#414141", px: 0, textDecoration: 'none!important' }}
                    onClick={() => setOpen(true)}
                    startIcon={<Menu />}
                  >
                    Main Menu
                  </Button>
                </Box>
              </Stack>
            )}
          </Container>
        </Box> */}
      </AppBar>
      {isOpen && (
        <Box sx={openMenuStyle}>
          <nav>
              <Stack direction={'column'} sx={{ width: '100%' }} alignItems={'stretch'}>
                <Box mb={1}>
                    <LinkList BoxContainerProps={{style: { width: '100%'}}} StackProps={{ direction: 'row',justifyContent: 'space-between', alignItems: 'stretch', width: '100%',  sx: { width: '100%'} }} requiredPublishType={requiredPublishType} onClick={() => setOpen(false)} links={[...allLinks.slice(1, 2)] as LinkGroupProps[]} LinkGroupItemsTypographyProps={{ sx: { textDecoration: 'none!important', fontWeight: 'bold', width: '100%' } }} LinkGroupHeaderLinkProps={{  sx: { textDecoration: 'none!important', fontWeight: 'bold', width: '100%' } }}  relativeLinkComponent={GatsbyLink} />
                </Box>
                <Box mb={4}>
                  <LinkList BoxContainerProps={{style: { width: '100%'}}} StackProps={{ direction: 'row',justifyContent: 'space-between', alignItems: 'stretch', width: '100%',  sx: { width: '100%'} }} requiredPublishType={requiredPublishType} onClick={() => setOpen(false)} links={[...allLinks.slice(2, 3)] as LinkGroupProps[]} LinkGroupItemsTypographyProps={{ sx: { textDecoration: 'none!important', fontWeight: 'bold', width: '100%' } }} LinkGroupHeaderLinkProps={{  sx: { textDecoration: 'none!important', fontWeight: 'bold', width: '100%' } }}  relativeLinkComponent={GatsbyLink} />
                </Box>

                  {allLinks && (
                      <LinkList StackProps={{ direction: 'column', divider: <Divider variant='fullWidth' sx={{ borderColor: '#E0E0E0' }} /> }} requiredPublishType={requiredPublishType} onClick={() => setOpen(false)} links={[...allLinks.slice(0, 1), ...allLinks.slice(3)] as LinkGroupProps[]} LinkGroupItemsTypographyProps={{ sx: { textDecoration: 'none!important', fontWeight: 'bold', width: '100%' } }} LinkGroupHeaderLinkProps={{ sx: { textDecoration: 'none!important', fontWeight: 'bold', width: '100%' } }} alignLeft relativeLinkComponent={GatsbyLink} />
                  )}
            </Stack>
          </nav>
        </Box>
      )}
    </>
  )
}
